module.exports = __webpack_public_path__ + "img/xbanner05.06a63a50.jpg";